export default {
  SET_SOURCE_ELEMENT: '@WS_EDITOR/DND/SET_DRAG_SOURCE_ELEMENT',
  SET_TARGET_ELEMENT: '@WS_EDITOR/DND/SET_DROP_TARGET_ELEMENT',
  SET_ADJACENT_POSITION: '@WS_EDITOR/DND/SET_ADJACENT_POSITION',
};
